/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rate-star-filled': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.234 23.787a.501.501 0 00-.467 0l-7.134 3.751a.502.502 0 01-.728-.529l1.363-7.944a.502.502 0 00-.145-.444l-5.77-5.626a.502.502 0 01.277-.855l7.976-1.158a.501.501 0 00.377-.275L15.55 3.48a.502.502 0 01.9 0l3.567 7.227c.073.148.214.251.378.275l7.975 1.158c.412.06.576.565.278.855l-5.771 5.626a.501.501 0 00-.144.444l1.363 7.944c.07.41-.36.723-.728.53l-7.134-3.752z" _fill="#EDB939"/>'
  }
})
